export const FOUNDED_YEAR = 2011;
export const yearsOfExperience = new Date().getFullYear() - FOUNDED_YEAR;
